import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import GeneralForm from '@components/Document/Forms/General';
import ContentLinkForm from '@components/Document/Forms/ContentLink';
import ContentDocument from '@components/Document/Forms/ContentDocument';
import ContentTexForm from '@components/Document/Forms/ContentText';
import ObligatoryForm from '@components/Document/Forms/Obligatory';
import VisibilityForm from '@components/Document/Forms/Visibility';
import PreviewForm from '@components/Document/Forms/Preview';
import JustificationModal from '@components/JustificationModal';
import LoadingAction from '@components/LoadingAction';


import { CLEAR_VALUES_DOCUMENT } from '@constants/actionType'
import { TypeDocuments } from '@constants/documents'
import { AuthorizedStatusSend, LANGUAGE_DEFAULT } from '@constants/general'
import { getLabelCompleteInTree, getLabelCompleteInTreeES} from '@utils/general'

import { getDetailDocument, updateDocument, changeStatusDocument, rejectDocument, deleteDocument, 
          renameDirDocument, getOnlyDetailDocument, deleteFile } from '@actions/documents';
import { sendActionToBitacora  } from '@actions/bitacora';

import store from '@store'

class StepsNewDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      maxStep:1,
      btnSubmitLoading: false,
      typeDocumentOrigin: '',
      loadingPage: true,
      loadingAction: false,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      }
    };
  }

  async componentDidMount() {
    const { history, getDetailDocument } = this.props
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_DOCUMENT,
      })
    }
    if (!history.location.state?.id) return history.push("/documents")

    await getDetailDocument({id: history.location.state.id})
    this.setState({typeDocumentOrigin: this.props._general.typeDocument})
    if (history.location.state?.isPending) this.setState({step: 2})
    this.setState({loadingPage: false})
  }

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  nexStep = async (data) => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    if (step === 0) await this.validateMaxStepEditComponents()
    if (step === 2) return this.updateDocument()
    // const validateMaxStep = step + 1 > maxStep ? step + 1 : maxStep
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = (data) => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  onConfirmAuthorized = (justification) => {
    const { t, id, changeStatusDocument, _document, getOnlyDetailDocument, _id_original} = this.props;
    this.setState({
      transactionNameOpt: 'autDocumento',
      loadingAction: true, 
      btnSubmitLoading: true
    }, async () => {
      const doctoOrigen = await getOnlyDetailDocument(_id_original ,{show:'no'})
      this.updateDocument({action: async () => {
        const response = await changeStatusDocument({id, type: AuthorizedStatusSend.STATUS_AUTHORIZED, justification})
        if (_document.general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF){
          await this.moveDocto(doctoOrigen?.data?.id_seccion, doctoOrigen?.data?.contenido)
        }
        if (!response.status) {
          await this.sendCommentToBitacora(justification)
        }
      }})

    // this.setState({
    //   showModalJustification: {
    //     isVisible: true,
    //     title: t('CONFIRMACIÓN'),
    //     description: t('¿Esta seguro que desea hacer este cambio?'),
    //     label: t('Justificación del cambio'),
    //     continueAction: ({justification}) => this.updateDocument(() => changeStatusDocument({id, type: AuthorizedStatusSend.STATUS_AUTHORIZED, justification})),
    //   },
    // });
    })
  }

  moveDocto = 
  async (idSeccion, contenido) => {
    const { id, getOnlyDetailDocument, _document, _id_original, categoriesSectionCatalog, renameDirDocument, _keysLenguages, deleteFile } = this.props;
    //moverDocumentos
    this.setState({ loadingAction: true, btnSubmitLoading: true });
    const doctoOrigen = await getOnlyDetailDocument(_id_original ,{show:'no'})
    console.log('ubicaciones', _document.general.selectedNavegationTree, idSeccion)
    
    if(idSeccion && (_document.general.selectedNavegationTree !== idSeccion)){
      _keysLenguages.map(key => {
        let oldNameDoc = contenido[key]
        const nameDoc = _document?.content?.document?.[key].file[0]?.fileName ? _document?.content?.document?.[key].file[0]?.fileName : _document.prevContentDoc[key]
        const newName = getLabelCompleteInTree(categoriesSectionCatalog,_document.general.selectedNavegationTree, `${key}/${nameDoc}`)
        const oldName = getLabelCompleteInTree(categoriesSectionCatalog,idSeccion,  `${key}/${nameDoc}`)
        
        console.log("ubica anterior", oldName)
        console.log("nueva ubica", newName)
        if(oldNameDoc === nameDoc){
          console.log("moviendo")
          renameDirDocument({oldName,newName},{show:'no'})
          
        } else {
          console.log("removiendo", oldNameDoc)
          oldNameDoc = getLabelCompleteInTree(categoriesSectionCatalog,idSeccion, `${key}/${oldNameDoc}`)
          deleteFile({ruta: oldNameDoc, type:'file'},{show:'no'})
          
        }
        
        
      })
    }

    this.setState({ loadingAction: false, btnSubmitLoading: false });
  }
  

  // onAuthorized = async (justification) => {
  //   const { changeStatusDocument, t, history, id } = this.props
  //   const type = "authorized"
  //   const response = await changeStatusDocument({id, type, justification})
  //   if(!response.status) {
  //     this.onHideModal()
  //     return confirmDialog({
  //       message: t('La operación se ha realizado de manera éxitosa'),
  //       header: t('Confirmación'),
  //       icon: 'pi pi-check-circle',
  //       acceptLabel: t('Continuar'),
  //       rejectClassName: 'hide-component',
  //       accept: () => history.push('/documents'),
  //       onHide: () => history.push('/documents')
  //     });
  //   }
  // }

  onConfirmSendAuthorized = (justification) => {
    const { t, id, changeStatusDocument, _document } = this.props;
    this.setState({
      transactionNameOpt: 'envAutDocumento',
      loadingAction: true, 
      btnSubmitLoading: true
    }, () => {
      this.updateDocument({action: async () => {
        const response = await changeStatusDocument({id, type: AuthorizedStatusSend.STATUS_PENDING, justification})
        //if (_document.general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF){
          //await moveDocto()
        //}
        if (!response.status) {
          await this.sendCommentToBitacora(justification)
        }
      }})
    })
    // this.setState({
    //   showModalJustification: {
    //     isVisible: true,
    //     title: t('CONFIRMACIÓN'),
    //     description: t('¿Esta seguro que desea hacer este cambio?'),
    //     label: t('Justificación del cambio'),
    //     continueAction: ({justification}) => this.updateDocument(() => changeStatusDocument({id, type: AuthorizedStatusSend.STATUS_PENDING, justification})),
    //   },
    // });
  }

  onConfirmReject = (justification) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => this.onReject(justification),
      },
    });
  };


  onReject = async (justification) => {
    const { changeStatusDocument, t, history, id } = this.props
    const response = await changeStatusDocument({id, type: AuthorizedStatusSend.STATUS_REJECTED, justification})
    if(!response.status) {
      this.setState({transactionNameOpt: 'rechazoDocumento'})
      await this.sendCommentToBitacora(justification)
      this.onHideModal()
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/documents'),
        onHide: () => history.push('/documents')
      });
    }
  }

  onConfirmDeleteVersion = () => {
    const { t } = this.props;
    
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar esta versión?'),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteVersion(justification),
      },
    });
  };


  onDeleteVersion = async (justification) => {
    const { deleteDocument, t, history, id, _general } = this.props
    const type = "physical"
    const response = await deleteDocument({id, type, justification, selectedNavegationTree: _general.selectedNavegationTree});

    if(!response.status) {
      this.setState({transactionNameOpt: 'elimVersionDocumento'})
      await this.sendCommentToBitacora(justification)
      this.onHideModal()
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/documents'),
        onHide: () => history.push('/documents')
      });
    }
  }

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  updateDocument = async ({ action, justification = ""}) => {
    const { history, t, updateDocument } = this.props
    this.setState({ loadingAction: true, btnSubmitLoading: true });
    try {
      let isErrorAction = false
      const response = await updateDocument()

      if (action) {
       let responseAct = await action()
       if (responseAct?.status) isErrorAction= true
      }
      if (!response.status && !isErrorAction) {
        if (!action) {
          await this.sendCommentToBitacora(justification)
        }
        this.setState({ loadingAction: false, btnSubmitLoading: false });
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/documents'),
          onHide: () => history.push('/documents')
        });
      }
      return this.setState({ loadingAction: false, btnSubmitLoading: false });
    } catch (error) {
      return this.setState({ loadingAction: false, btnSubmitLoading: false });
    }
  }

  sendCommentToBitacora = async (justification) => {
    const { _general, sendActionToBitacora, _id_original, getDetailDocument } = this.props
    const { transactionNameOpt } = this.state
    let nameDocument = ''
    if (_id_original) {
      const response = await getDetailDocument({id: _id_original, setToState: false})
      if (!response?.status) nameDocument = response.data.nombre[LANGUAGE_DEFAULT]
      else nameDocument = _general[LANGUAGE_DEFAULT].name
    } else {
      nameDocument = _general[LANGUAGE_DEFAULT].name
    }
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Documento',
      reason: `${nameDocument} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  onUpdateSection = (justification) => {
    this.setState({transactionNameOpt: 'actDocumento'}, () => {
      this.updateDocument({justification})
    })
  }

  validateMaxStepEditComponents = () => {
    const { typeDocumentOrigin } = this.state
    const { _general } = this.props
    if (!typeDocumentOrigin) this.setState({typeDocumentOrigin: _general.typeDocument})
    else if (_general?.typeDocument !== typeDocumentOrigin) {
      this.setState({maxStep: 1, typeDocumentOrigin: _general.typeDocument})
    }
  }

  render() {
    const { step, btnSubmitLoading, loadingPage, showModalJustification  } = this.state;
    const { t, _document } = this.props;

    const steps = [
      { label: t("Datos generales"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Contenido"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Obligatoriedad"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Visibilidad"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Vista Previa"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const stepsRender = () => {
      if (step === 0) {
        return (
          <GeneralForm
            success={this.nexStep}
            // onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            //isEdit
          />
        );
      }
      if (step === 1) {
        if (_document.general.typeDocument === TypeDocuments.IS_LINK) {
          return (
            <ContentLinkForm
              // success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}
              isEdit

              success={this.onUpdateSection}
              authorize={this.onConfirmAuthorized}
              sendAuthorize={this.onConfirmSendAuthorized}
              reject={this.onConfirmReject}
              deleteVersion={this.onConfirmDeleteVersion}
            />
          )
        }
        if (_document.general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF) {
          return (
            <ContentDocument
              // success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}
              isEdit

              success={this.onUpdateSection}
              authorize={this.onConfirmAuthorized}
              sendAuthorize={this.onConfirmSendAuthorized}
              reject={this.onConfirmReject}
              deleteVersion={this.onConfirmDeleteVersion}
            />
          )
        }
        if (_document.general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT) {
          return (
            <ContentTexForm
              // success={this.nexStep}
              onBack={this.backStep}
              btnSubmitLoading={btnSubmitLoading}
              isEdit

              success={this.onUpdateSection}
              authorize={this.onConfirmAuthorized}
              sendAuthorize={this.onConfirmSendAuthorized}
              reject={this.onConfirmReject}
              deleteVersion={this.onConfirmDeleteVersion}
            />
          );
        }
      }
      if (step === 2) {
        return (
          <ObligatoryForm
            success={this.onUpdateSection}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            isEdit

            authorize={this.onConfirmAuthorized}
            sendAuthorize={this.onConfirmSendAuthorized}
            reject={this.onConfirmReject}
            deleteVersion={this.onConfirmDeleteVersion}
          />
        );
      }
      // if (step === 3) {
      //   return (
      //     <VisibilityForm
      //       success={this.nexStep}
      //       authorize={this.nexStep}
      //       reject={this.onConfirmReject}
      //       deleteVersion={this.onConfirmDeleteVersion}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //       isEdit
      //     />
      //   );
      // }
      // if (step === 4) {
      //   return (
      //     <PreviewForm
      //       success={this.nexStep}
      //       authorize={this.nexStep}
      //       onBack={this.backStep}
      //       reject={this.onConfirmReject}
      //       deleteVersion={this.onConfirmDeleteVersion}
      //       btnSubmitLoading={btnSubmitLoading}
      //       isEdit
      //     />
      //   );
      // }

      return true;
    };

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos del documento")} linkText={t("Ir al listado")} to="/documents" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>

            {stepsRender()}
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        { this.state.loadingAction && <LoadingAction/> }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  languagesCatalog: state.catalogs.languagesCatalog,
  _general: state.document.general,
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
  _keysLenguages: state.catalogs.keysLanguageCatalog,
  _document: state.document,
  id: state.document.id,
  _id_original: state.document.id_original
});

const mapDispatchToProps = {
  getDetailDocument,
  getOnlyDetailDocument,
  updateDocument,
  renameDirDocument,
  deleteFile,
  changeStatusDocument,
  rejectDocument,
  deleteDocument,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(StepsNewDocument);
